import React from "react";
import { AppCategory, ConnectionData } from "../types";
import AppCard from "./AppCard";

interface BrowseAppsProps {
  categories: AppCategory[];
  installedApps: ConnectionData[];
  refetchConnections: () => Promise<void>;
  featuredAppKeys: string[];
}

const BrowseApps: React.FC<BrowseAppsProps> = ({
  categories,
  installedApps,
  refetchConnections,
  featuredAppKeys,
}) => {
  return (
    <div className="px-4 pb-4 mt-4">
      {categories.map((category) => (
        <div
          key={category.name}
          className={category.name === "Featured" ? "mb-4" : ""}
        >
          {category.apps.map((app) => {
            // Find the matching installed app by platform/name or key
            const matchingInstalledApp = installedApps.find(
              (connection) =>
                connection.platform.toLowerCase() === app.name.toLowerCase() ||
                connection.key.toLowerCase() === app.key.toLowerCase(),
            );

            // Check if this app is already installed
            const isInstalled = !!matchingInstalledApp;

            return (
              <AppCard
                key={app.name}
                icon={
                  <img
                    src={app.image}
                    alt={app.name}
                    className="w-full h-full object-contain"
                  />
                }
                name={app.name}
                description={app.description}
                isInstalled={isInstalled}
                connectionId={matchingInstalledApp?._id}
                refetchConnections={refetchConnections}
                isFeatured={featuredAppKeys.includes(app.platform)}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default React.memo(BrowseApps);
